import React, { FunctionComponent, useContext } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import _uniqueId from 'lodash/uniqueId'
import classnames from 'classnames'

import { PageHeading } from '../../..'
import AddForm from './AddForm'

import { AppContext } from '../../../../contexts'

import styles from './styles.module.css'

import { WebsitesStore } from '../../../../typings/website'

interface WebsitesProps extends RouteComponentProps {
  basePath: string
  websites: WebsitesStore
  showAddForm?: boolean
  closeAdd(): void
  addWebsite(): void
}

const Websites: FunctionComponent<WebsitesProps> = ({
  history,
  basePath,
  websites,
  showAddForm,
  closeAdd,
  addWebsite,
}) => {
  const { isAuthorized } = useContext(AppContext)

  return (
    <>
      <PageHeading title="Websites" className={styles.heading}>
        <span className={styles.titleNote}>
          <strong>NOTE:</strong> You are only allowed to use approved program
          links on the specific website they have been approved for. This is for
          compliance reasons and advertiser requirements. Due to regular
          monitoring of links, in the event approved links are used on a
          non-approved website, your account risks the possibility of being
          removed from our network.
        </span>
        {isAuthorized('manager') && (
          <div className={styles.actionContainer}>
            <button
              className={styles.add}
              onClick={() => {
                history.push(`${basePath}/add`)
              }}
              data-rv="website-add"
            >
              Add New Website
            </button>
          </div>
        )}
      </PageHeading>
      <div className={styles.listContainer}>
        {websites.data.records.map(website => (
          <div key={_uniqueId(`${website.id}-`)} className={styles.panel}>
            <div className={styles.label}>Site Name:</div>
            <div className={styles.data}>{website.name}</div>
            <div className={styles.label}>Website ID:</div>
            <div className={styles.data}>{website.id}</div>
            <div className={styles.label}>URL:</div>
            <div className={styles.data}>
              <a href={website.url} target="_blank">
                {website.url}
              </a>
            </div>
            <div className={styles.label}>API Key:</div>
            <div className={styles.data}>{website.apiKey}</div>
            <div className={styles.label}>Description:</div>
            <div className={styles.data}>{website.description}</div>
            <div className={styles.right}>
              <div className={styles.label}>Status:</div>
              <div
                className={classnames(styles.status, {
                  [styles.approved]:
                    website.approvalStatus.toLowerCase() === 'approved',
                  [styles.declined]:
                    website.approvalStatus.toLowerCase() === 'declined',
                })}
              >
                {website.approvalStatus}
              </div>
            </div>
          </div>
        ))}
      </div>
      {showAddForm && <AddForm close={closeAdd} addWebsite={addWebsite} />}
    </>
  )
}

export default withRouter(Websites)
